import { Component, Input } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AmpliacaoService } from 'src/app/modules/services/ampliacao/ampliacao.service';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { PageStateService } from 'src/app/modules/services/page-state/page-state.service';
import { LoadingService } from '../../../loading/loading.service';
import { take, finalize, Subscription } from 'rxjs';
import { ModalComponent } from '../../../modal/modal.component';
import { AlertComponent } from '../../../alert/alert.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ModalController } from '@ionic/angular';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ModalFiltersComponent } from 'src/app/modules/shared/modals/modal-filters/modal-filters.component';
import { ImportModalComponent } from 'src/app/modules/shared/modals/import-modal/import-modal.component';
import { ImportValidationComponent } from 'src/app/modules/shared/modals/import-validation/import-validation.component';

@Component({
  selector: 'app-ampliacao',
  templateUrl: './ampliacao.component.html',
  styleUrls: ['./ampliacao.component.scss']
})
export class AmpliacaoComponent {
  /** Inputs */
  @Input() contractId: string | null = '';
  @Input() buttonInclusaoDisabled: boolean = false;
  @Input() buttonEdicaoDisabled: boolean = false;
  @Input() buttonExclusaoDisabled: boolean = false;
  @Input() cnpj: any;
  subsctiptions: Subscription[] = [];
  /** Tabela */
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [];
  readonly columnConfig = [
    { columnDef: 'codigo', header: 'Código', property: 'codigo' },
    { columnDef: 'tipoObra', header: 'Tipo de obra', property: 'tipoObra.nome' },
    { columnDef: 'kmInicial', header: 'KM Inicial', property: 'kmInicial' },
    { columnDef: 'kmFinal', header: 'KM Final', property: 'kmFinal' },
    { columnDef: 'kmExtensao', header: 'Extensão', property: 'kmExtensao' },
    { columnDef: 'prazoVigenteInicial', header: 'Prazo Vigente Inicial', property: 'prazoVigenteInicial', customTd: true },
    { columnDef: 'prazoVigenteFinal', header: 'Prazo Vigente Final', property: 'prazoVigenteFinal', customTd: true },
    { columnDef: 'statusParametro', header: 'Status', property: 'statusParametro.descricao', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];
  arrayStatus: any = [
    { label: "Ativo", property: "", selected: false },
    { label: "Cancelado", property: "", selected: false },
  ]
  /** Ordenação */
  sortState = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc' as 'asc' | 'desc'
  };

  /** Paginação */
  pageIndex = 0;
  pageSize = 10;
  totalPages = 1;
  totalElements = 0;

  /** Layout */
  screenWidth = window.innerWidth;

  /** Filtro */
  statusFilter: any;
  filterData: any;
  formServicoAmpliacao!: FormGroup;
  criterios: any = [];
  criteriosLabels!: { [key: string]: string; };
  tiposObra: any[] = [];
  nomeTipoObra: string | null = '';
  constructor(
    private router: Router,
    private ampliacaoService: AmpliacaoService,
    private pageStateService: PageStateService,
    private pageSizeService: PageSizeService,
    private loadingService: LoadingService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private modalCtrl: ModalController,
    private fb: FormBuilder,
  ) {
  this.formServicoAmpliacao = this.fb.group({
      codigo: [''],
      idTipoObra: [null],
      kmInicial: [null],
      kmFinal: [null],
      prazoVigenteInicial: [null],
      prazoVigenteFinal: [null],
      kmExtensao: [null]
    });
    this.buildCriteriosLabels();
  }
  private buildCriteriosLabels() {
    this.criteriosLabels = {
      codigo: 'Código',
      idTipoObra: 'Tipo de obra',
      kmInicial: 'Km inicial',
      kmFinal: 'Km final',
      prazoVigenteInicial: 'Prazo vigente inicial',
      prazoVigenteFinal: 'Prazo vigente final',
      prazoAnaliseFuncional: 'Prazo Funcional',
      prazoAnaliseExecutivo: 'Prazo Executivo',
      kmExtensao: 'Extensão'
    };
  }
  ngOnInit(): void {
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);
    this.restorePageState();
    this.getData(this.pageIndex);
    this.carregarTipos();
  }

  /** Navegar para criação de novo serviço */
  create(): void {
    this.router.navigate([`contrato/${this.contractId}/detalhes/criar-ampliacao`]);
  }

  /** Buscar dados da tabela */
  getData(pageIndex: number = 0): void {
    const { sortDirection, sortProperty } = this.sortState;

    this.ampliacaoService.getServicosAmpliacao(
      this.pageSize,
      pageIndex,
      sortDirection,
      sortProperty,
      this.contractId,
      this.statusFilter,
      this.filterData,
      this.nomeTipoObra
    ).subscribe((resp: any) => this.handleResponse(resp));
  }

  /** Tratar resposta da API */
  private handleResponse(resp: any): void {
    const { content, pageSize, totalPages, totalElements, pageNumber } = resp;

    this.dataSource.data = content ?? [];
    this.pageSize = pageSize ?? this.pageSize;
    this.totalPages = totalPages ?? 0;
    this.totalElements = totalElements ?? 0;
    this.pageIndex = pageNumber ?? 0;
  }

  /** Alterar ordenação */
  onSortChange(sortProperty: string): void {
    this.sortState.sortDirection =
      this.sortState.sortProperty === sortProperty
        ? (this.sortState.sortDirection === 'asc' ? 'desc' : 'asc')
        : 'asc';

    this.sortState.sortProperty = sortProperty;
    this.getData();
  }

  /** Evento de mudança de página */
  pageChangeEvent(event: PageEvent): void {
    const pageChanged = this.pageIndex !== event.pageIndex;
    const sizeChanged = this.pageSize !== event.pageSize;

    if (sizeChanged) {
      this.pageSize = event.pageSize;
      this.pageSizeService.setPageSize(event.pageSize);
      this.getData(0);
      return;
    }

    if (pageChanged) {
      this.getData(event.pageIndex);
    }
  }

  /** Recuperar estado salvo da página */
  private restorePageState(): void {
    const savedPageIndex = this.pageStateService.getPageState(this.router.url);
    if (savedPageIndex) {
      this.pageIndex = savedPageIndex;
    }
  }

  openActivateDialog(id: any): void {
    const modalTitle: string = 'Ativar';
    const modalContent: string =
      'Você tem certeza que deseja ativar este serviço?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onActivateModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });

  }
  onActivateModalConfirm(id: any): void {
    this.loadingService.showLoading();
    let data = {
      idContrato: this.contractId,
      idServico: id,
    };

    this.ampliacaoService
      .ativarServicos(this.contractId, id, data)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          this.openSnackBar('Serviço ativado com sucesso!', 'sucess');
          this.getData(0);
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            return this.openSnackBar(erro.error.message, 'error');
          }
          if (erro.error.error == 'Unprocessable Entity') {
            return this.openSnackBar(erro.error.message, 'warning');
          } else {
            return this.openSnackBar(
              'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
              'error'
            );
          }
        },
      });
  }
  openInactivateDialog(id: number): void {
    const modalTitle: string = 'Cancelar';
    const modalContent: string =
      'Você tem certeza que deseja cancelar este serviço?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onCancelModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });

  }
  onCancelModalConfirm(id: any): void {
    this.loadingService.showLoading();
    let data = {
      idContrato: this.contractId,
      idServico: id,
    };

    this.ampliacaoService
      .cancelarServicos(this.contractId, id, data)
      .pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      )
      .subscribe({
        next: (res: any) => {
          this.openSnackBar('Serviço cancelado com sucesso!', 'sucess');
          this.getData(0);
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            return this.openSnackBar(erro.error.message, 'error');
          }
          if (erro.error.error == 'Unprocessable Entity') {
            return this.openSnackBar(erro.error.message, 'warning');
          } else {
            return this.openSnackBar(
              'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
              'error'
            );
          }
        },
      });
  }
  openDeleteDialog(id: number): void {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja excluir este Serviço?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });
  }
  onDeleteModalConfirm(id: any): void {
    this.loadingService.showLoading();

    this.subsctiptions.push(
      this.ampliacaoService.deleteServico(id, this.contractId).pipe(
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe({
        next: (resp: any) => {
          this.openSnackBar('Serviço deletado com sucesso.', 'sucess');
          this.getData();
        }, error: (err: any) => {
          this.openSnackBar(err.error.message, 'error');
        }
      })

    );
  }

  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
  async openDialogHistoricoServicoInicial(id: number) {
    const data = {
      type: 'servicoAmpliacao',
      id: id,
      contracId: this.contractId,
      fieldMappings: {
        origemObra: 'Origem da Obra',
        tipoObra: 'Tipo da Obra',
        codigo: 'Código',
        descricaoServico: 'Descrição do serviço',
        anoConclusao: 'Ano de conclusão',
        rodovia: 'Rodovia',
        sentido: 'Sentido da via',
        segmentoHomogeneo: 'Segmento homogêneo',
        kmInicial: 'Km inicial',
        kmFinal: 'Km final',
        kmExtensao: 'Extensão',
        kmCampoInicial: 'Km campo inicial',
        kmCampoFinal: 'Km campo final',
        naturezaPrazo: 'Natureza do prazo',
        prazoInicial: 'Prazo inicial',
        prazoFinal: 'Prazo final',
        prazoVigenteInicial: 'Prazo vigente inicial',
        prazoVigenteFinal: 'Prazo vigente final',
        valorObra: 'Valor da obra',
        valorObraAtualizado: 'Valor atualizado da obra',
        latitudeInicial: 'Latitude inicial',
        latitudeFinal: 'Latitude final',
        longitudeInicial: 'Longitude inicial',
        longitudeFinal: 'Longitude final',
        statusParametro: 'Status do parâmetro',
        dataAfericao: 'Data da aferição',
        statusAtual: 'Status atual da aferição',
        municipios: 'Municípios',
        prazoAnaliseFuncional: 'Prazo Funcional',
        prazoAnaliseExecutivo: 'Prazo Executivo',
      }
    }
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: {
        data: data,
        fieldMappings: data.fieldMappings,
      },
    });

    modal.present();
  }

  openModalFilters(popover?: any) {

    let props;
    if (this.filterData) {
      props = this.filterData;
    } else {
      props = this.generatePropsFromForm(this.formServicoAmpliacao);
    }

    const data = {
      type: 'servicosAmpliacao',
      propsServicosAmpliacao: props
    };

    const dialogRef = this.dialog.open(ModalFiltersComponent, {
      panelClass: ['ampliacao-panel'],
      data,
    });

    dialogRef.afterClosed().subscribe({
      next: (data: any) => {
        if (data) {
          // Atualiza os critérios com base nos dados do modal
          if (data.value.idTipoObra) {
            const tipoObraObj = this.tiposObra.find(resp => resp.id == data.value.idTipoObra);
            if (tipoObraObj) { this.nomeTipoObra = tipoObraObj.nome }
          } else {
            this.nomeTipoObra = '';
          }
          this.filterData = data;
          this.criterios = this.getCriterios(data);
          this.getData();
        }
      }
    });
  }

  // Função para gerar o objeto props de forma dinâmica a partir dos valores do formulário
  private generatePropsFromForm(form: FormGroup): any {
    const props: any = {};
    // Itera sobre os controles do FormGroup
    Object.keys(form.controls).forEach((controlName: string) => {
      const control = form.get(controlName);

      // Verifica se o controle tem valor e não é nulo ou vazio
      if (control && control.value !== null && control.value !== undefined && control.value !== '') {
        props[controlName] = control.value;
      }
    });
    return props;
  }

  getCriterios(data: any) {
    const criterios = [];

    // Gera os critérios de forma dinâmica, verificando os valores dos campos
    const props: any = this.generatePropsFromForm(data);

    for (const prop in props) {
      if (props[prop] !== null && props[prop] !== undefined && props[prop] !== '') {
        criterios.push(prop);
      }
    }

    return criterios;
  }
  criterioRemoved(event: any) {
    // Lógica para remover da lista de critérios, se necessário
    this.filterData.patchValue({
      [event.criterio]: null
    });
    this.criterios = this.criterios.filter((c: any) => c !== event.criterio);
    if (!this.filterData.value.idTipoObra) {
      this.nomeTipoObra = '';
    }
    this.getData();
  }

  redirectToEditPage(idServicoAmpliacao: number): void {
    this.router.navigate([`contrato/${this.contractId}/detalhes/editar-ampliacao/${idServicoAmpliacao}`]);
  }
  filterStatusChanged(event: {}) {
    this.statusFilter = event;
    this.getData();
  }
  carregarTipos(nome?: string) {
    this.ampliacaoService.getTiposObra(0, 50, nome).subscribe({
      next: (res: any) => (this.tiposObra = res.content),
      error: err => console.error('Erro ao carregar tipos', err)
    });
  }

  openImportModal(event:any) {
        const data = {isServicoAmpliacao: true};
        const dialogRef = this.dialog.open(ImportModalComponent, {
          panelClass: ['anotation-panel'],
          data,
        });
      
    
        dialogRef.afterClosed().subscribe({
          next: (file: any) => {
            if (file) {
              // this.openModalImportValidation(mockDataValid, file);
              this.loadingService.showLoading();
              this.ampliacaoService
                .validateImport(this.contractId, file)
                .pipe(
                  finalize(() => {
                    this.loadingService.hideLoading();
                  })
                )
                .subscribe({
                  next: (res: any) => {
                    this.openModalImportValidation(res, file);
    
                    // this.openSnackBar('Rodovia importada com sucesso.', 'sucess');
                  },
                  error: (err: any) => {
                    this.openSnackBar(err.error.message, 'error');
                  },
                });
            }
          },
        });
      }
         openModalImportValidation(resp:any, file: any){
            
            const data = {
              resp: resp,
              file:file,
              from:'servicos-ampliacao'
            };
        
            const dialogTableValidation = this.dialog.open(ImportValidationComponent, {
        
              width: '800px',
              height: '850px',
              data,
            });
        
            dialogTableValidation.afterClosed().subscribe({
              next: (res: any) => {
                if (res && !res.retry) {
                  this.loadingService.showLoading();
                  this.ampliacaoService
                    .import(this.contractId, resp, file, this.cnpj)
                    .pipe(
                      finalize(() => {
                        this.loadingService.hideLoading();
                      })
                    )
                    .subscribe({
                      next: (res: any) => {
                        this.getData();
                        this.openSnackBar('Importação finalizada com sucesso.', 'sucess');
                      },
                      error: (err: any) => {
                        this.openSnackBar(err.error.message, 'error');
                      },
                    });
                }else{
                  if(res.retry){
                    this.openImportModal(0);
                  }
                }
              },
            });
          }

}
